(function () {
  class MulticolumnScrollbar {
    constructor(scrollbar) {
      this.scrollbar = scrollbar;
      this.drag = scrollbar.querySelector('.multicolumn-scrollbar__drag');
      const sliderComponent = scrollbar.closest('slider-component');
      this.list = sliderComponent?.querySelector('.multicolumn-list.slider');
      if (!this.list || !this.drag) return;

      this.pointerId = null;
      this.startX = 0;
      this.startScroll = 0;
      this.trackWidth = 0;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);

      this.list.addEventListener('scroll', this.onScroll, { passive: true });
      this.drag.addEventListener('pointerdown', this.onPointerDown);
      window.addEventListener('resize', this.onResize);

      if (typeof ResizeObserver !== 'undefined') {
        this.ro = new ResizeObserver(() => this.onScroll());
        this.ro.observe(this.list);
      }

      requestAnimationFrame(this.onScroll);
    }

    onResize() {
      this.onScroll();
    }

    onScroll() {
      const { scrollLeft, scrollWidth, clientWidth } = this.list;
      const overflow = scrollWidth - clientWidth;

      if (overflow <= 1) {
        this.scrollbar.classList.remove('multicolumn-scrollbar--active');
        return;
      }

      this.scrollbar.classList.add('multicolumn-scrollbar--active');

      const thumbWidthPct = Math.max((clientWidth / scrollWidth) * 100, 10);
      const maxLeftPct = 100 - thumbWidthPct;
      const progress = scrollLeft / overflow;
      const leftPct = maxLeftPct * progress;

      this.drag.style.width = `${thumbWidthPct}%`;
      this.drag.style.left = `${leftPct}%`;
    }

    onPointerDown(event) {
      event.preventDefault();
      this.pointerId = event.pointerId;
      this.startX = event.clientX;
      this.startScroll = this.list.scrollLeft;
      this.trackWidth = this.scrollbar.getBoundingClientRect().width;
      this.scrollbar.classList.add('multicolumn-scrollbar--dragging');

      try {
        this.drag.setPointerCapture(event.pointerId);
      } catch (_) {
        /* pointer capture may fail on some browsers — ignore */
      }

      this.drag.addEventListener('pointermove', this.onPointerMove);
      this.drag.addEventListener('pointerup', this.onPointerUp);
      this.drag.addEventListener('pointercancel', this.onPointerUp);
    }

    onPointerMove(event) {
      if (event.pointerId !== this.pointerId) return;
      const dx = event.clientX - this.startX;
      const overflow = this.list.scrollWidth - this.list.clientWidth;
      if (overflow <= 0 || this.trackWidth <= 0) return;

      const scrollDelta = (dx / this.trackWidth) * this.list.scrollWidth;
      this.list.scrollLeft = Math.max(0, Math.min(this.startScroll + scrollDelta, overflow));
    }

    onPointerUp(event) {
      if (event.pointerId !== this.pointerId) return;
      this.scrollbar.classList.remove('multicolumn-scrollbar--dragging');

      try {
        this.drag.releasePointerCapture(event.pointerId);
      } catch (_) {
        /* ignore */
      }

      this.drag.removeEventListener('pointermove', this.onPointerMove);
      this.drag.removeEventListener('pointerup', this.onPointerUp);
      this.drag.removeEventListener('pointercancel', this.onPointerUp);
      this.pointerId = null;
    }
  }

  function init(root) {
    const scope = root instanceof Element ? root : document;
    scope.querySelectorAll('.multicolumn-scrollbar').forEach((el) => {
      if (el.dataset.scrollbarBound === 'true') return;
      el.dataset.scrollbarBound = 'true';
      new MulticolumnScrollbar(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
